import Progress from "@/components/Progress";

export default function CareerGoalsStepProgress({
  stepIndex,
  stepsLength
}: {
  stepIndex: number;
  stepsLength: number;
}) {
  const current = stepIndex + 1;
  const progressValue = stepsLength > 0 ? current / stepsLength : 0;

  return (
    <div className="rounded-lg bg-sys-brand-surface-container-low px-4 py-3" data-testid="career-intent-progress">
      <div className="flex items-center gap-3">
        <span
          aria-hidden="true"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sys-brand-primary text-title-small-bold text-sys-brand-on-primary"
        >
          {current}
        </span>
        <p className="text-title-medium-bold text-sys-brand-on-surface">
          Question {current} of {stepsLength}
        </p>
      </div>
      <div aria-hidden="true" className="mt-3">
        <Progress className="w-full" variant="linear" value={progressValue} />
      </div>
    </div>
  );
}
